__turbopack_context__.v({
  "blok-big-title": "CartItems-module___bOMMa__blok-big-title",
  "blok-subtitle": "CartItems-module___bOMMa__blok-subtitle",
  "blok-title": "CartItems-module___bOMMa__blok-title",
  "group-container": "CartItems-module___bOMMa__group-container",
  "groups-wrapper": "CartItems-module___bOMMa__groups-wrapper",
  "isCheckout": "CartItems-module___bOMMa__isCheckout",
});
